module.exports = __webpack_public_path__ + "img/admin-old.e457ce01.png";